import URL from '../api_url';

export const SESSION_PROGRAM_API = `${URL}/program-session`;

export const SESSION_PROGRAMS_API = `${URL}/program-sessions`;
